import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// CREATE ACTION
export const fetchCreateAdjustmentRequest = createAsyncThunk(
  "fetchCreateAdjustmentRequest",
  async (requestData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      const response = await axiosHttp.post(
        "adjustment-request/create",
        requestData,
        config
      );

      message.success("Adjustment request created successfully!");

      return response.data.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to create adjustment request";
      message.error(errorMessage);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const createAdjustmentRequestSlice = createSlice({
  name: "createAdjustmentRequest",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    resetCreateAdjustmentRequest: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCreateAdjustmentRequest.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(fetchCreateAdjustmentRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    });

    builder.addCase(fetchCreateAdjustmentRequest.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetCreateAdjustmentRequest } = createAdjustmentRequestSlice.actions;

export default createAdjustmentRequestSlice.reducer;
